import { styled, IconButton } from '@mui/material';

export const CopyButtonIconButton = styled(IconButton)(({ theme, color }) => ({
  ...(color === 'default' && {
    color: theme.palette.grey[500],
  }),
}));
